/**
 * Terms of Service version. Must match TERMS_VERSION in backend/constants.py.
 *
 * Bump both when the terms change materially: new sign-ups accept the new
 * version, and signed-in users whose recorded version differs are asked to
 * accept again (see components/TermsGate.js).
 */
export const TERMS_VERSION = '2026-09-28';
export const TERMS_EFFECTIVE = 'September 28, 2026';

export function hasAcceptedCurrentTerms(user) {
  return Boolean(user && user.termsVersion === TERMS_VERSION);
}

export function formatAcceptedAt(epochSeconds) {
  if (!epochSeconds) return null;
  try {
    return new Date(epochSeconds * 1000).toLocaleString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return null;
  }
}
